export * from './umpire-component-hero-generic';
